import { Component, EventEmitter, Input, OnChanges, Output, ViewChild } from "@angular/core";
import { DayOfWeek } from "@enums/DayOfWeek";
import { SchedulingFrequency } from "@reports/enums/SchedulingFrequency";
import { IDynamicReportSchedule } from "@reports/models/IDynamicReportSchedule";
import { IReportDefinition } from "@reports/models/IReportDefinition";
import { ExportType } from "@reports/_services/dynamicReports.service";
import { ReportSchedulesComponent } from "../../_components/report-schedules/report-schedules.component";
import "./report-schedule-page.component.scss";

@Component({
    selector: "report-schedule-page",
    template: require("./report-schedule-page.component.html")
})
export class ReportSchedulePageComponent implements OnChanges {
    @Input() reportId: number;
    @Output() scheduleClick = new EventEmitter<IDynamicReportSchedule>();

    // ---

    reports: IReportDefinition[];
    schedules: IDynamicReportSchedule[];
    selectedSchedule: IDynamicReportSchedule;

    @ViewChild(ReportSchedulesComponent, { static: false }) reportSchedules: ReportSchedulesComponent

    constructor() {
    }

    ngOnChanges() {
    }

    addSchedule() {
        this.editSchedule({
            Name: "",
            Frequency: SchedulingFrequency.Weekly,
            ReportDefinitionId: this.reportId,
            ExportType: ExportType.PDF,
            RepeatOn: [DayOfWeek.Monday],
            Active: true,
            SendTo: [""]
        });
    }

    editSchedule(schedule: IDynamicReportSchedule) {
        this.selectedSchedule = schedule;
    }

    onCreateScheduleClicked(): void {
        this.addSchedule();
    }

    onScheduleEditorSaved(schedule: IDynamicReportSchedule) {
        this.clearSelectedSchedule();

        this.reportSchedules?.scheduleSaved(schedule);
    }

    onScheduleEditorDeleted(schedule: IDynamicReportSchedule) {
        this.clearSelectedSchedule();

        this.reportSchedules?.scheduleDeleted(schedule);
    }

    // ---

    private clearSelectedSchedule(): void {
        this.selectedSchedule = null;
    }

}
